import { ParentStatus, StatusData } from "src/api/General/status-groups";

export type Logic = "AND" | "OR";

export type IdComparator = "eq" | "in" | "nin";

export type DateComparator = "eq" | "gt" | "gte" | "lt" | "lte";

export type NumberComparator = "eq" | "gt" | "gte" | "lt" | "lte";

// Task Status

export type TaskStatusFilter = {
  field: "task-status";
  comparator: IdComparator;
  value: {
    status: ParentStatus;
    customStatus: string;
  }[];
};

export type TaskStatusFilterModel = {
  field: "task-status";
  statuses: StatusData[];
};

// Project

export type ProjectFilter = {
  field: "project";
  comparator: IdComparator;
  value: string[];
};

export type ProjectFilterModel = {
  field: "project";
};

// Project Status

export type ProjectStatusFilter = {
  field: "project-status";
  comparator: IdComparator;
  value: string[];
};

export type ProjectStatusFilterModel = {
  field: "project-status";
  // statuses: StatusData[];
};

// Space

export type SpaceFilter = {
  field: "space";
  comparator: IdComparator;
  value: string[];
};

export type SpaceFilterModel = {
  field: "space";
  spaces: {
    _id: string;
    color: string;
    name: string;
  }[];
};

// Company

export type CompanyFilter = {
  field: "company";
  comparator: IdComparator;
  value: string[];
};

export type CompanyFilterModel = {
  field: "company";
};

// Start Date

export type StartDateFilter = {
  field: "project-start-date";
  comparator: DateComparator;
  value: string;
};

export type StartDateFilterModel = {
  field: "project-start-date";
};

// Project Progress

export type ProjectProgressFilter = {
  field: "project-progress";
  comparator: NumberComparator;
  value: number;
};

export type ProjectProgressFilterModel = {
  field: "project-progress";
};

// Project Active Time

export type ProjectActiveTimeFilter = {
  field: "project-active-time";
  comparator: NumberComparator;
  value: number;
};

export type ProjectActiveTimeFilterModel = {
  field: "project-active-time";
};

// Project Owner

export type ProjectOwnerFilter = {
  field: "project-owner";
  comparator: IdComparator;
  value: string[];
};

export type ProjectOwnerFilterModel = {
  field: "project-owner";
  projectOwners: {
    _id: string;
    name: string;
    email: string;
  }[];
};

// Task Due Date

export type TaskDueDateFilter = {
  field: "task-dueDate";
  comparator: DateComparator;
  value: string | null;
};

export type TaskDueDateFilterModel = {
  field: "task-dueDate";
};

// Task Assignee

export type TaskerFilter = {
  field: "tasker";
  comparator: IdComparator;
  value: string[];
};

export type TaskerFilterModel = {
  field: "tasker";
  taskers: {
    name: string;
    _id: string;
  }[];
};

// Priority

export type TaskPriorityFilter = {
  field: "task-priority";
  comparator: IdComparator;
  value: string[];
};

export type TaskPriorityFilterModel = {
  field: "task-priority";
  priorities: string[];
};

// Project Name

export type ProjectNameFilter = {
  field: "name";
  comparator: "contains";
  value: string;
};

// Project Template

export type ProjectTemplateFilter = {
  field: "project-template";
  comparator: IdComparator;
  value: string[];
};

export type ProjectTemplateFilterModel = {
  field: "project-template";
  projectTemplates: {
    _id: string;
    name: string;
  }[];
};

// Inactive To Do Tasks

export type InactiveToDoTasksFilter = {
  field: "inactive-todo-tasks";
  comparator: "eq";
  value: boolean;
};

// local storage

export function getAllTasksFilterKey() {
  return `filter_all_tasks`;
}

export function getMyTasksFilterKey() {
  return `filter_my_tasks`;
}

export function getSpaceTasksFilterKey(spaceId: string) {
  return `filter_space_tasks_${spaceId}`;
}

export function getSpaceProjectsFilterKey(spaceId: string) {
  return `filter_space_projects_${spaceId}`;
}

export function getProjectTimeTrackingAnalyticsFilterKey() {
  return `filter_project_time_tracking_analytics`;
}

export function getProjectFinancialsAnalyticsFilterKey() {
  return `filter_project_financials_analytics`;
}

export function getProjectsMilestonesAnalyticsFilterKey() {
  return `filter_projects_milestones_analytics`;
}

export function getProjectProgressAndDatesFilterKey() {
  return `filter_project_progress_and_dates`;
}

export function getAverageCompletionTimeFilterKey() {
  return `filter_project_average_completion_time`;
}

export function getProjectMomentumFilterKey() {
  return `filter_project_momentum`;
}

export function getSpaceProjectsColumnsToDisplayKey(spaceId: string) {
  return `columns_space_projects_${spaceId}`;
}

export function getAnalyticsTabKey() {
  return `analytics_tab`;
}

export function getTimeTrackingTabKey() {
  return `time_tracking_tab`;
}

export function getTimeEntriesFilterKey() {
  return "filter_time_entries";
}

export function getInternalProjectUpdatesDueDateFilterKey() {
  return "filter_internal_project_updates_due_date";
}
  
